export default __webpack_public_path__ + "assets/images/Logo_NXT.png";